import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { Accordion, Button, Col, Form, Row } from "react-bootstrap";
import SimpleSelect from "../common/SimpleSelect";
import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { saveProductMapping } from "../../store/slices/saveProductMapping";
import { createproductcatalog } from "../../store/slices/createPreExistingProduct";
import { getConfig } from "../../store/slices/getConfig";
import {syncStatus} from "../../store/slices/syncStatus"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const validationSchema = Yup.object({
  pim_product_identifier: Yup.object().required("Product Identifier is Required"),
  pim_variant_identifier: Yup.object().required("Variant Identifier is Required")
});

function ProductCatlog_configuration( {showToast, changeTab}) {

  const [actionType, setActionType] = useState("");
  const configId = useSelector((state) => state.saveCreds.configId);
  const domain = useSelector((state)=> state.config.data.targetClientDomain);
  const savedData = useSelector((state) => state.config.data);
  const productMappingStatus = useSelector((state)=> state.productMapping.status);
  const preExistingProductStatus = useSelector(state => state.preExistingProductCatalog);
  const optionsData = useSelector(state => state.PImAttributes.optionsData);
  const defaultOption = useSelector((state) => state.PImAttributes.display);
  const preExistingProductStatusbyConfig = useSelector((state)=> state.config?.data?.attributeMapping?.isPreExistingProductCompleted);
  const dispatch = useDispatch();
  const [showMsg, setShowMsg] = useState(false);


  const getInitialValues = useCallback(() => {
  const productIdentifier =
    savedData?.attributeMapping?.inventory?.sku?.pimAttribute;

  const variantIdentifier =
    savedData?.attributeMapping?.variantMapping?.sku?.pimAttribute;

  return {
    pim_product_identifier: productIdentifier
      ? {
          value: productIdentifier,
          label: defaultOption?.[productIdentifier] || productIdentifier,
        }
      : null,

    pim_variant_identifier: variantIdentifier
      ? {
          value: variantIdentifier,
          label: defaultOption?.[variantIdentifier] || variantIdentifier,
        }
      : null,
  };
}, [savedData, defaultOption]);

  const formik = useFormik({
    initialValues: getInitialValues(),
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {

      const req = {
        attributeMapping: {
          ...savedData?.attributeMapping,
          inventory: {
            sku: {
              shopifyType: "String",
              pimAttribute: values.pim_product_identifier.value || "",
              clientDefaultValue: "",
              pimType: "pim_catalog_identifier",
              shopifyDefaultValue: ""
            },
          },
          variantMapping: {
            sku: {
              shopifyType: "String",
              pimAttribute: values.pim_variant_identifier.value || "",
              clientDefaultValue: "",
              pimType: "pim_variant_identifier",
              shopifyDefaultValue: ""
            }
          },
          isPreExistingCatalog: savedData?.attributeMapping?.isPreExistingCatalog || "false",
          isPreExistingCategoriesCompleted: savedData?.attributeMapping?.isPreExistingCategoriesCompleted || "null",
          isPreExistingProductCompleted: "MappingSaved",
        },
        struConfigId: configId || savedData?.struConfigId
      };

      const generateReq = {
        storeDomain: savedData?.targetClientDomain
      };

      try {
        if (actionType === "save") {
          // 1️⃣ Save mapping
          await dispatch(saveProductMapping(req)).unwrap();

          // 2️⃣ Get updated config
          await dispatch(getConfig(domain)).unwrap();

          // ✅ Toast after success
          showToast?.("saveattributeMapping");
        }

        if (actionType === "generate") {
          // 1️⃣ Create product catalog
          await dispatch(createproductcatalog(generateReq)).unwrap();

          // 2️⃣ Update mapping after generation
          const updatedReq = {
            attributeMapping: {
              ...savedData?.attributeMapping,
              isPreExistingCategoriesCompleted: savedData?.attributeMapping?.isPreExistingCategoriesCompleted,
              isPreExistingProductCompleted: "Completed"
            },
            struConfigId: configId || savedData?.struConfigId
          };

          await dispatch(saveProductMapping(updatedReq)).unwrap();

          // 3️⃣ Refresh config
          await dispatch(getConfig(domain)).unwrap();
        }

      } catch (error) {
      }
    },
  });

  // Memoized sort function
  const sortArray = useCallback((array) => {
    if (array.length > 0) {
      return [...array].sort((a, b) => a.label.localeCompare(b.label));
    }
    return array;
  }, []);

  const getFieldOptions = useCallback((field) => {
      const set = new Set();
      const arr = [];
  
      field.forEach((dataType) => {
        optionsData.forEach((optionGroup) => {
          if (optionGroup[dataType]) {
            optionGroup[dataType].forEach((option) => {
              if (!set.has(option.code)) {
                set.add(option.code);
                arr.push({
                  value: option.code,
                  label: option.displayName ?? option.code,
                });
              }
            });
          }
        });
      });
  
      return sortArray(arr);
    }, [optionsData, sortArray]);

    const monitorStatus = () => {
      if (savedData !== null) {
        dispatch(syncStatus(savedData?.struConfigId));
      }
      changeTab("sync-status")
    }
  
    useEffect(() => {
      if ((savedData?.attributeMapping?.isPreExistingProductCompleted === "Completed" || savedData?.attributeMapping?.isPreExistingProductCompleted === "MappingSaved") && preExistingProductStatus?.status == "SUCCESS") {
        setShowMsg(true);
  
        const timer = setTimeout(() => {
          setShowMsg(false);
        }, 60000); // 10 sec
  
        return () => clearTimeout(timer); // cleanup
      }
    }, [preExistingProductStatus?.status]);


  return (
    <div className="mt-4">
      <Form onSubmit={formik.handleSubmit}>
        <Accordion.Item eventKey="2" className="my-1">
          <Accordion.Header>
            Pre-existing Product Mapping (optional)
          </Accordion.Header>
          <Accordion.Body className="p-4">
            <div className="bg-light p-4 rounded mb-10 mapping_component">
              <Row className="border-bottom pb-3 mb-3 align-items-center">
                <Col sm={12}>
                  <h6 className="fw-bold m-0">Pre-existing Products</h6>
                </Col>
              </Row>
              <Row>
                <Col sm={5}>
                  <h6 className="fw-bold mb-4">Shopify Product Identifier</h6>
                </Col>
                <Col sm={5} className="mx-5">
                  <h6 className="fw-bold mb-4 ms-5">PIM Product Identifier</h6>
                </Col>
              </Row>

              <Row>
                <Col sm={5}>
                  <Form.Group controlId="s_product_identifer">
                    <Form.Control
                      name="shopify_product_sku"
                      value="SKU"
                      readonly
                    />
                  </Form.Group>
                </Col>

                <Col
                  sm={1}
                  className="d-flex justify-content-center compareIcon"
                >
                  <CompareArrowsIcon className="mt-2" />
                </Col>

                <Col sm={5}>
                  <Form.Group controlId={"p_product_identifer"}>
                    <SimpleSelect
                      name="pim_product_identifier"
                      value={formik.values.pim_product_identifier || null}
                      onChange={formik.setFieldValue}
                      onBlur={formik.setFieldTouched}
                      touched={formik.touched.pim_product_identifier}
                      options={getFieldOptions(["pim_catalog_identifier"])}
                      isInvalid={
                        formik.touched.pim_product_identifier &&
                        formik.errors.pim_product_identifier
                      }
                      error={formik.errors.pim_product_identifier}
                      isClearable={true}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.pim_product_identifier}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <div className="infoIcon">
                    <InfoOutlinedIcon fontSize="30px"/>
                      <p className="custom-field-note ms-2 mt-3">
                        If SKU in Shopify is not your Product Identifier, please contact us.
                      </p>
              </div>
            </div>
            <div className="bg-light p-4 rounded mb-10 mapping_component">
              <Row className="border-bottom pb-3 mb-3 align-items-center">
                <Col sm={12}>
                  <h6 className="fw-bold m-0">
                    Pre-existing Products with Variants
                  </h6>
                </Col>
              </Row>
              <Row>
                <Col sm={5}>
                  <h6 className="fw-bold mb-4">Shopify Variant Identifier</h6>
                </Col>
                <Col sm={5} className="mx-5">
                  <h6 className="fw-bold mb-4 ms-5">PIM Variant Identifier</h6>
                </Col>
              </Row>

              <Row>
                <Col sm={5}>
                  <Form.Group controlId="s_variant_identifer">
                    <Form.Control
                      name="shopify_variant_identifier"
                      value="SKU"
                      readonly
                    />
                  </Form.Group>
                </Col>

                <Col
                  sm={1}
                  className="d-flex justify-content-center compareIcon"
                >
                  <CompareArrowsIcon className="mt-2" />
                </Col>

                <Col sm={5}>
                  <Form.Group controlId={"p_product_identifer"}>
                    <SimpleSelect
                      name="pim_variant_identifier"
                      value={formik.values.pim_variant_identifier || null}
                      onChange={formik.setFieldValue}
                      onBlur={formik.setFieldTouched}
                      touched={formik.touched.pim_variant_identifier}
                      options={getFieldOptions(["pim_catalog_identifier"])}
                      isInvalid={
                        formik.touched.pim_variant_identifier &&
                        formik.errors.pim_variant_identifier
                      }
                      error={formik.errors.pim_variant_identifier}
                      isClearable={true}
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.pim_variant_identifier}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
               <div className="infoIcon">
                    <InfoOutlinedIcon fontSize="30px"/>
                      <p className="custom-field-note ms-2 mt-3">
                        If SKU in Shopify is not your Variant Identifier, please contact us.
                      </p>
                </div>
            </div>
            <Row className="mt-5 mx-3">
              <Col sm={12}>
                <Button variant="primary"
                 type="submit" 
                 className="stru-btn savemapping" 
                 onClick={() => setActionType("save")}
                 disabled = {((preExistingProductStatusbyConfig == "MappingSaved")) || (preExistingProductStatusbyConfig == "Completed")}
                 >
                  {(preExistingProductStatusbyConfig == "null" && productMappingStatus == "Loading") && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                    </div>}
                  Save Mapping
                </Button>
                <Button variant="primary"
                  type="submit"
                  className="stru-btn" 
                  onClick={() => setActionType("generate")}
                  disabled={!(preExistingProductStatusbyConfig == "MappingSaved") || (preExistingProductStatusbyConfig == "Completed")}
                  >
                    {preExistingProductStatus.status == "Inprogress" && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                    </div>}
                  Generate Mapping
                </Button>
                {preExistingProductStatus.status == "Inprogress" &&<>
                  <div className="infoIcon">
                    <InfoOutlinedIcon fontSize="30px" style={{fill:"red"}}/>
                    <p className="custom-field-note ms-2 mt-3 text-danger fs-13">
                      Mapping generation in progress, this activity may takes a few minutes
                    </p>
                    </div>
                    <Button
                      type="button"
                      variant="primary"
                      className="job-link p-0 ms-2"
                      onClick={() => monitorStatus()}
                    >
                      <span
                        style={{
                          color: "#000",
                          textDecoration:"underline"
                        }}
                        className="fs-13"
                      >
                      Check your sync job status.
                      </span>
                    </Button>
                    </>
                }
                {showMsg &&<>
                  <br />
                  <Button
                    type="button"
                    variant="primary"
                    className="job-link p-0 ms-2 mt-2"
                    onClick={() => monitorStatus()}
                  >
                    <span
                    className="fs-13"
                      style={{
                        color: "#000",
                        textDecoration:"underline"
                      }}
                    >
                    Check your sync job status.
                    </span>
                  </Button>
                  </>
                }
                {(preExistingProductStatusbyConfig == "Completed") ?
                    <div className="infoIcon">
                      <InfoOutlinedIcon fontSize="30px"/>
                        <p className="custom-field-note ms-2 mt-3 fs-13">
                           Mapping has been generated. You may start syncing products now. If you want to regenerate mapping, contact us.
                        </p>
                    </div> :
                    <div className="infoIcon">
                      <InfoOutlinedIcon fontSize="30px"/>
                      <p className="custom-field-note ms-2 mt-3 fs-13">
                        This section allows you to link pre-existing shopify products or variants to your products in PIM. This mapping can only be generated once.
                      </p>
                    </div>
                }
                
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      </Form>
    </div>
  );
}

export default ProductCatlog_configuration;
